const SITE_NAME = 'Store Credit';

const VALID_ITEM_IDENTIFIER_PATTERN = /^(\d+|\d+-\d+|VALPN-\d+)$/i;

const TIMEOUT = 60 * 1000;

const href = window.location.href;
let nbaBaseUrl;
if (href.includes('-dev') || href.includes('localhost')) {
    nbaBaseUrl = 'https://dev-admin.vistaauction.com';
} else if (href.includes('-stage')) {
    nbaBaseUrl = 'https://stage-admin.vistaauction.com';
} else {
    nbaBaseUrl = 'https://admin.vistaauction.com';
}
const NBA_BASE_URL = nbaBaseUrl;

const AUCTION_NUMBER_CUTOFF = 20000000;

export {SITE_NAME, VALID_ITEM_IDENTIFIER_PATTERN, TIMEOUT, NBA_BASE_URL, AUCTION_NUMBER_CUTOFF};
